import CardItem from './components/CardItem';
import ListItem from './components/ListItem';
import LastReplies from './components/LastReplies';
import craftTags from "./utils/craftTags";
import craftBadges from "./utils/craftBadges";

export default {
  'dem13n/discussion/cards/components/CardItem': CardItem,
  'dem13n/discussion/cards/components/ListItem': ListItem,
  'dem13n/discussion/cards/components/LastReplies': LastReplies,
  'dem13n/discussion/cards/utils/craftTags': craftTags,
  'dem13n/discussion/cards/utils/craftBadges': craftBadges,
};
